import React, { useEffect, useState } from "react";
import { Offcanvas, Badge, Card, Row, Col, ProgressBar, Table, Form } from "react-bootstrap";
import { FaEdit, FaExclamationTriangle, FaLock } from "react-icons/fa";
import { NoDataFoundTable } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsKitMetadataServices } from "../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";
import { useParams } from "react-router";

const SiteDetail = ({ Show, Hide, Title, rowData, userList, eiwrsPermission }) => {
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [columns, setColumns] = useState([]);
  let { studyId } = useParams();

  const getEIWRSKitMetadataData = async (e) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
    );
    setColumns(data?.data || []);
  };

  console.log(">>>", columns);


  useEffect(() => {
    getEIWRSKitMetadataData();
  }, []);
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 600 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 style={{ fontSize: 14 }} className="mb-1">{rowData?.row?.SITENAME}</h5>
            <span className="text-muted font-monospace small">{rowData?.row?.SITEID}</span>
          </div>
          <Badge
            bg="success-subtle"
            style={{padding: "1px 10px"}}
            className={`br3 text-success px-2 py-1 text-capitalize`}
          >
            Active
          </Badge>
        </div>
        <Card className="mb-3">
          <Card.Body>
            <div className="d-flex justify-content-between small">
              <div>
                <span className="text-muted">Min Stock</span>
                <div className="text-center">{rowData?.totalKit - rowData?.usedKit}</div>
              </div>
              <div>
                <span className="text-muted">Max Stock</span>
                <div className="text-center">{rowData?.totalKit}</div>
              </div>
              <div>
                <span className="text-muted">Resupply Threshold</span>
                <div className="text-center">{rowData?.row?.[StudyMode === "DBP Mode" ? "EIWRSDBPKITTHRESHOLD" : StudyMode === "Live Mode" ? "EIWRSLIVEKITTHRESHOLD" : "EIWRSQCKITTHRESHOLD"]}</div>
              </div>
            </div>
          </Card.Body>
        </Card>
        <Card className="mb-3">
          <Card.Body>
            <div className="d-flex justify-content-between small">
              <div className="hstack gap-2">
                <span className="text-muted">Stock Level</span>
                {rowData?.usedKit >= Number(rowData?.row?.[StudyMode === "DBP Mode" ? "EIWRSDBPKITTHRESHOLD" : StudyMode === "Live Mode" ? "EIWRSLIVEKITTHRESHOLD" : "EIWRSQCKITTHRESHOLD"]) &&
                  <span style={{ fontSize: 12 }} className="hstack gap-1 text-danger small mt-1">
                    <FaExclamationTriangle size={10} className="me-1" />
                    Below resupply threshold
                  </span>
                }
                {rowData?.expiredKit &&
                  <span style={{ fontSize: 12 }} className="hstack gap-1 text-warning small mt-1">
                    <FaExclamationTriangle size={10} className="me-1" />
                    Some kits expiring soon (Within 7 days)
                  </span>
                }
                {rowData?.kitProgress > 90 &&
                  <span style={{ fontSize: 10 }} className="hstack gap-1 text-danger">
                    <FaExclamationTriangle size={10} className="me-1" />
                    {rowData?.kitProgress === 100 ? "Finished Stock" : "Low Stock"}
                  </span>
                }
              </div>
              <span className="text-muted small fw-bold">
                {rowData?.usedKit} / {rowData?.totalKit} max
                <span className="text-muted fw-normal ms-1">· threshold {rowData?.row?.[StudyMode === "DBP Mode" ? "EIWRSDBPKITTHRESHOLD" : StudyMode === "Live Mode" ? "EIWRSLIVEKITTHRESHOLD" : "EIWRSQCKITTHRESHOLD"]}</span>
              </span>
            </div>
            <ProgressBar
              now={rowData?.kitProgress}
              variant={rowData?.kitProgress > 90 ? "danger" : rowData?.kitProgress > 80 ? "warning" : "success"}
              style={{ height: 5 }}
              className="mt-1"
            />
            
          </Card.Body>
        </Card>
        <Card className="mb-3">
          <Card.Body>
            <h6 className="text-uppercase text-muted" style={{ fontSize: "11px", letterSpacing: "0.5px", fontWeight: "700" }}>
              KIT STATISTICS
            </h6>
            <Row className="g-1 mb-2">
              <Col xs={3}>
                <div className="text-center p-1 bg-light rounded">
                  <div className="small text-muted">Total</div>
                  <Form.Label className="m-0">{rowData?.totalKit}</Form.Label>
                </div>
              </Col>
              <Col xs={3}>
                <div className="text-center p-1 bg-success bg-opacity-10 rounded">
                  <div className="small text-success" style={{fontSize: 11}}>Available</div>
                  <Form.Label className="m-0">{rowData?.totalKit - rowData?.usedKit}</Form.Label>
                </div>
              </Col>
              <Col xs={3}>
                <div className="text-center p-1 bg-info bg-opacity-10 rounded">
                  <div className="small text-info" style={{fontSize: 11}}>Dispensed</div>
                  <Form.Label className="m-0">{rowData?.usedKit}</Form.Label>
                </div>
              </Col>
              <Col xs={3}>
                <div className="text-center p-1 bg-danger bg-opacity-10 rounded">
                  <div className="small text-danger" style={{fontSize: 11}}>Quarantine</div>
                  <Form.Label className="m-0">{rowData?.totalQuarantinedKit}</Form.Label>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card className="mb-3">
          <Card.Body>
            <h6 className="text-uppercase text-muted" style={{ fontSize: "11px", letterSpacing: "0.5px", fontWeight: "700" }}>
              SUBJECT STATISTICS
            </h6>
            <div className="d-flex justify-content-between small">
              <div>
                <span className="text-muted">Subjects</span>
                <div className="text-center">{rowData?.totalSubject}</div>
              </div>
              <div>
                <span className="text-muted">Randomized</span>
                <div className="text-center">{rowData?.totalRandomizedSubject}</div>
              </div>
              <div>
                <span className="text-muted">Dispensed</span>
                <div className="text-center">{rowData?.usedKit}</div>
              </div>
            </div>
          </Card.Body>
        </Card>
        <h6 className="text-uppercase text-muted" style={{ fontSize: "11px", letterSpacing: "0.5px", fontWeight: "700" }}>
          KITS ON HAND
        </h6>
        {(rowData?.totalKitList || [])?.length === 0 ? (
          <div>
            <NoDataFoundTable MSG={`Study Kit not found!`} /> 
          </div>
        ) : (
          <Table className="m-0 custom-table" hover>
            <thead className="position-sticky top-0 z-1">
              <tr>
                {columns?.filter(column => column?.isUnique === "yes")?.map(item => (
                  <th>
                    {item?.columnLabel}
                  </th>
                ))}
                <th>Kit</th>
                <th>Treatment</th>
                <th>Expiry</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {(rowData?.totalKitList || [])?.map((item, index) => (
                <tr key={index}>
                  {columns
                    ?.filter((column) => column?.isUnique === "yes")
                    ?.map((column) => {
                      const columnData = (item?.columns || [])?.find(
                        (ele) => ele?.columnName === column?.columnName
                      );

                      return (
                        <td key={column?.columnId || column?.columnName}>
                          {columnData?.columnValue || ""}
                        </td>
                      );
                    })}
                  <td className="font-monospace">{item?.kitNumber}</td>
                  <td>
                    {(eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                      item?.treatmentName
                      :
                      <Badge style={{ width: 50 }} className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>
                    }
                  </td>
                  <td>{item?.expiryDate}</td>
                  <td className={`fw-bold text-capitalize ${item?.status === "dispensed" ? "text-success" : (item?.status === "quarantined" || item?.status === "expired") ? "text-danger" : "text-warning"}`}>{item?.status === "allocated" ? "Allocated at Site" : item?.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SiteDetail;